module.exports = __webpack_public_path__ + "static/img/max_pictgrid23_1060x886.b8a15db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid23_1060x886.jpg
// module id = I411
// module chunks = 0